import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'zpl-preview-modal',
  templateUrl: './zpl-preview.modal.component.html',
  styleUrls: ['./zpl-preview.modal.component.scss']
})
export class ZplPreviewModalComponent implements OnInit, OnDestroy {
  labels: string[] = [];
  labelPreviews: SafeUrl[] = [];
  onConfirm: () => void;

  constructor(
    public modalRef: BsModalRef,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.generatePreviews();
  }

  ngOnDestroy() {
    // Clean up all blob URLs when component is destroyed
    this.labelPreviews.forEach(preview => {
      if (preview) {
        URL.revokeObjectURL(preview.toString());
      }
    });
    this.labelPreviews = [];
  }

  async generatePreviews() {
    this.labelPreviews = await Promise.all(
      this.labels.map(zpl => {
        return this.getZplPreview(zpl)
      })
    );
  }

  private async getZplPreview(zpl: string): Promise<SafeUrl> {
    try {
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('Accept', 'image/png');

      // Add cache-busting parameter
      const apiUrl = `https://api.labelary.com/v1/printers/8dpmm/labels/4x6/0/?ts=${Date.now()}`;

      const response = await this.http.post(
        apiUrl,
        zpl,
        { 
          responseType: 'blob',
          headers: headers
        }
      ).toPromise();

      // Create and sanitize blob URL
      const blob = new Blob([response], { type: 'image/png' });
      const blobUrl = URL.createObjectURL(blob);
      return this.sanitizer.bypassSecurityTrustUrl(blobUrl);
    } catch (error) {
      console.error('Error generating preview:', error);
      return null;
    }
  }

  confirmPrint() {
    this.onConfirm();
    this.modalRef.hide();
  }
} 


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/modals/zpl-preview-modal/zpl-preview.modal.component.ts